export default __webpack_public_path__ + "static/cli_cruzverde-442a0a61962bdafe0a3aa97d39a907b9.png";